module.exports = __webpack_public_path__ + "static/media/face-white.2a35811c.svg";